import React from 'react'
import { useTranslation } from 'react-i18next'
import { TitleController } from '@pandiafi/design-system'
import {
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { DataLoader } from './DocumentsDataLoader'
import { DocumentCategoryInfo } from './DocumentCategoryInfo'
import { ErrorHandler } from './DocumentsErrorHandler'

import { Error } from 'components'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'

export const Documents: React.FC = () => {
  const { t } = useTranslation(['common', 'titles', 'documents'])
  const { frontPagePath } = useContractPaths()

  return (
    <TitleController title={t('titles:documents')}>
      <ResidentAppView
        title={t('common:views.documents')}
        backLink={
          <ResidentAppBackLink href={frontPagePath}>
            {t('common:views.home')}
          </ResidentAppBackLink>
        }
      >
        <ResidentAppCard>
          <ErrorHandler>
            <DataLoader>
              {({ data }) => {
                if (!data.length) {
                  return (
                    <Error
                      illustration="box-empty"
                      message={t('documents:errors.noDocuments')}
                    />
                  )
                }

                return data.map(({ category, documents }) => (
                  <DocumentCategoryInfo
                    key={category.id}
                    category={category}
                    docs={documents}
                  />
                ))
              }}
            </DataLoader>
          </ErrorHandler>
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
